export { AtnDsStepperComponent as Component } from './stepper.component'
export * as child from './components'
